import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _assertThisInitialized from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _objectSpread from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var Pe = globalThis,
  At = Pe.ShadowRoot && (Pe.ShadyCSS === void 0 || Pe.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype,
  St = Symbol(),
  Qt = /* @__PURE__ */new WeakMap();
var _r = /*#__PURE__*/function () {
  function _r(r, e, t) {
    _classCallCheck(this, _r);
    if (this._$cssResult$ = !0, t !== St) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = r, this.t = e;
  }
  _createClass(_r, [{
    key: "toString",
    value: function toString() {
      return this.cssText;
    }
  }, {
    key: "styleSheet",
    get: function get() {
      var r = this.o;
      var e = this.t;
      if (At && r === void 0) {
        var t = e !== void 0 && e.length === 1;
        t && (r = Qt.get(e)), r === void 0 && ((this.o = r = new CSSStyleSheet()).replaceSync(this.cssText), t && Qt.set(e, r));
      }
      return r;
    }
  }]);
  return _r;
}();
var eo = function eo(r) {
    return new _r(typeof r == "string" ? r : r + "", void 0, St);
  },
  qe = function qe(r) {
    for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      e[_key - 1] = arguments[_key];
    }
    var t = r.length === 1 ? r[0] : e.reduce(function (o, n, s) {
      return o + function (a) {
        if (a._$cssResult$ === !0) return a.cssText;
        if (typeof a == "number") return a;
        throw Error("Value passed to 'css' function must be a 'css' function result: " + a + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
      }(n) + r[s + 1];
    }, r[0]);
    return new _r(t, r, St);
  },
  to = function to(r, e) {
    if (At) r.adoptedStyleSheets = e.map(function (t) {
      return t instanceof CSSStyleSheet ? t : t.styleSheet;
    });else {
      var _iterator = _createForOfIteratorHelper(e),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          var o = document.createElement("style"),
            n = Pe.litNonce;
          n !== void 0 && o.setAttribute("nonce", n), o.textContent = t.cssText, r.appendChild(o);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  },
  Zt = At ? function (r) {
    return r;
  } : function (r) {
    return r instanceof CSSStyleSheet ? function (e) {
      var t = "";
      var _iterator2 = _createForOfIteratorHelper(e.cssRules),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var o = _step2.value;
          t += o.cssText;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return eo(t);
    }(r) : r;
  };
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ro = Object.is,
  oo = Object.defineProperty,
  io = Object.getOwnPropertyDescriptor,
  no = Object.getOwnPropertyNames,
  ao = Object.getOwnPropertySymbols,
  so = Object.getPrototypeOf,
  me = globalThis,
  Xt = me.trustedTypes,
  lo = Xt ? Xt.emptyScript : "",
  Jt = me.reactiveElementPolyfillSupport,
  Se = function Se(r, e) {
    return r;
  },
  Fe = {
    toAttribute: function toAttribute(r, e) {
      switch (e) {
        case Boolean:
          r = r ? lo : null;
          break;
        case Object:
        case Array:
          r = r == null ? r : JSON.stringify(r);
      }
      return r;
    },
    fromAttribute: function fromAttribute(r, e) {
      var t = r;
      switch (e) {
        case Boolean:
          t = r !== null;
          break;
        case Number:
          t = r === null ? null : Number(r);
          break;
        case Object:
        case Array:
          try {
            t = JSON.parse(r);
          } catch (_unused) {
            t = null;
          }
      }
      return t;
    }
  },
  wt = function wt(r, e) {
    return !ro(r, e);
  },
  er = {
    attribute: !0,
    type: String,
    converter: Fe,
    reflect: !1,
    hasChanged: wt
  };
Symbol.metadata != null || (Symbol.metadata = Symbol("metadata")), me.litPropertyMetadata != null || (me.litPropertyMetadata = /* @__PURE__ */new WeakMap());
var de = /*#__PURE__*/function (_HTMLElement) {
  _inherits(de, _HTMLElement);
  _createClass(de, null, [{
    key: "addInitializer",
    value: function addInitializer(e) {
      var t;
      this._$Ei(), ((t = this.l) != null ? t : this.l = []).push(e);
    }
  }, {
    key: "createProperty",
    value: function createProperty(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : er;
      if (t.state && (t.attribute = !1), this._$Ei(), this.elementProperties.set(e, t), !t.noAccessor) {
        var o = Symbol(),
          n = this.getPropertyDescriptor(e, o, t);
        n !== void 0 && oo(this.prototype, e, n);
      }
    }
  }, {
    key: "getPropertyDescriptor",
    value: function getPropertyDescriptor(e, t, o) {
      var n;
      var _ref = (n = io(this.prototype, e)) != null ? n : {
          get: function get() {
            return this[t];
          },
          set: function set(c) {
            this[t] = c;
          }
        },
        s = _ref.get,
        a = _ref.set;
      return {
        get: function get() {
          return s == null ? void 0 : s.call(this);
        },
        set: function set(c) {
          var h = s == null ? void 0 : s.call(this);
          a.call(this, c), this.requestUpdate(e, h, o);
        },
        configurable: !0,
        enumerable: !0
      };
    }
  }, {
    key: "getPropertyOptions",
    value: function getPropertyOptions(e) {
      var t;
      return (t = this.elementProperties.get(e)) != null ? t : er;
    }
  }, {
    key: "_$Ei",
    value: function _$Ei() {
      if (this.hasOwnProperty(Se("elementProperties"))) return;
      var e = so(this);
      e.finalize(), e.l !== void 0 && (this.l = _toConsumableArray(e.l)), this.elementProperties = new Map(e.elementProperties);
    }
  }, {
    key: "finalize",
    value: function finalize() {
      if (this.hasOwnProperty(Se("finalized"))) return;
      if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(Se("properties"))) {
        var t = this.properties,
          o = [].concat(_toConsumableArray(no(t)), _toConsumableArray(ao(t)));
        var _iterator3 = _createForOfIteratorHelper(o),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var n = _step3.value;
            this.createProperty(n, t[n]);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      var e = this[Symbol.metadata];
      if (e !== null) {
        var _t2 = litPropertyMetadata.get(e);
        if (_t2 !== void 0) {
          var _iterator4 = _createForOfIteratorHelper(_t2),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _step4$value = _slicedToArray(_step4.value, 2),
                _o2 = _step4$value[0],
                _n = _step4$value[1];
              this.elementProperties.set(_o2, _n);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }
      this._$Eh = /* @__PURE__ */new Map();
      var _iterator5 = _createForOfIteratorHelper(this.elementProperties),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
            _t3 = _step5$value[0],
            _o3 = _step5$value[1];
          var _n2 = this._$Eu(_t3, _o3);
          _n2 !== void 0 && this._$Eh.set(_n2, _t3);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this.elementStyles = this.finalizeStyles(this.styles);
    }
  }, {
    key: "finalizeStyles",
    value: function finalizeStyles(e) {
      var t = [];
      if (Array.isArray(e)) {
        var o = new Set(e.flat(1 / 0).reverse());
        var _iterator6 = _createForOfIteratorHelper(o),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var n = _step6.value;
            t.unshift(Zt(n));
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      } else e !== void 0 && t.push(Zt(e));
      return t;
    }
  }, {
    key: "_$Eu",
    value: function _$Eu(e, t) {
      var o = t.attribute;
      return o === !1 ? void 0 : typeof o == "string" ? o : typeof e == "string" ? e.toLowerCase() : void 0;
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return this.finalize(), this._$Eh && _toConsumableArray(this._$Eh.keys());
    }
  }]);
  function de() {
    var _this;
    _classCallCheck(this, de);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(de).call(this)), _this._$Ep = void 0, _this.isUpdatePending = !1, _this.hasUpdated = !1, _this._$Em = null, _this._$Ev();
    return _this;
  }
  _createClass(de, [{
    key: "_$Ev",
    value: function _$Ev() {
      var _this2 = this;
      var e;
      this._$ES = new Promise(function (t) {
        return _this2.enableUpdating = t;
      }), this._$AL = /* @__PURE__ */new Map(), this._$E_(), this.requestUpdate(), (e = this.constructor.l) == null || e.forEach(function (t) {
        return t(_this2);
      });
    }
  }, {
    key: "addController",
    value: function addController(e) {
      var t, o;
      ((t = this._$EO) != null ? t : this._$EO = /* @__PURE__ */new Set()).add(e), this.renderRoot !== void 0 && this.isConnected && ((o = e.hostConnected) == null || o.call(e));
    }
  }, {
    key: "removeController",
    value: function removeController(e) {
      var t;
      (t = this._$EO) == null || t.delete(e);
    }
  }, {
    key: "_$E_",
    value: function _$E_() {
      var e = /* @__PURE__ */new Map(),
        t = this.constructor.elementProperties;
      var _iterator7 = _createForOfIteratorHelper(t.keys()),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var o = _step7.value;
          this.hasOwnProperty(o) && (e.set(o, this[o]), delete this[o]);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      e.size > 0 && (this._$Ep = e);
    }
  }, {
    key: "createRenderRoot",
    value: function createRenderRoot() {
      var e;
      var t = (e = this.shadowRoot) != null ? e : this.attachShadow(this.constructor.shadowRootOptions);
      return to(t, this.constructor.elementStyles), t;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var e;
      this.renderRoot != null || (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$EO) == null || e.forEach(function (t) {
        var o;
        return (o = t.hostConnected) == null ? void 0 : o.call(t);
      });
    }
  }, {
    key: "enableUpdating",
    value: function enableUpdating(e) {}
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var e;
      (e = this._$EO) == null || e.forEach(function (t) {
        var o;
        return (o = t.hostDisconnected) == null ? void 0 : o.call(t);
      });
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(e, t, o) {
      this._$AK(e, o);
    }
  }, {
    key: "_$EC",
    value: function _$EC(e, t) {
      var o;
      var n = this.constructor.elementProperties.get(e),
        s = this.constructor._$Eu(e, n);
      if (s !== void 0 && n.reflect === !0) {
        var a = (((o = n.converter) == null ? void 0 : o.toAttribute) !== void 0 ? n.converter : Fe).toAttribute(t, n.type);
        this._$Em = e, a == null ? this.removeAttribute(s) : this.setAttribute(s, a), this._$Em = null;
      }
    }
  }, {
    key: "_$AK",
    value: function _$AK(e, t) {
      var o;
      var n = this.constructor,
        s = n._$Eh.get(e);
      if (s !== void 0 && this._$Em !== s) {
        var a = n.getPropertyOptions(s),
          c = typeof a.converter == "function" ? {
            fromAttribute: a.converter
          } : ((o = a.converter) == null ? void 0 : o.fromAttribute) !== void 0 ? a.converter : Fe;
        this._$Em = s, this[s] = c.fromAttribute(t, a.type), this._$Em = null;
      }
    }
  }, {
    key: "requestUpdate",
    value: function requestUpdate(e, t, o) {
      var n;
      if (e !== void 0) {
        if (o != null || (o = this.constructor.getPropertyOptions(e)), !((n = o.hasChanged) != null ? n : wt)(this[e], t)) return;
        this.P(e, t, o);
      }
      this.isUpdatePending === !1 && (this._$ES = this._$ET());
    }
  }, {
    key: "P",
    value: function P(e, t, o) {
      var n;
      this._$AL.has(e) || this._$AL.set(e, t), o.reflect === !0 && this._$Em !== e && ((n = this._$Ej) != null ? n : this._$Ej = /* @__PURE__ */new Set()).add(e);
    }
  }, {
    key: "_$ET",
    value: function () {
      var _$ET2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var e;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.isUpdatePending = !0;
              _context.prev = 1;
              _context.next = 4;
              return this._$ES;
            case 4:
              _context.next = 9;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              Promise.reject(_context.t0);
            case 9:
              e = this.scheduleUpdate();
              _context.t1 = e != null;
              if (!_context.t1) {
                _context.next = 14;
                break;
              }
              _context.next = 14;
              return e;
            case 14:
              return _context.abrupt("return", !this.isUpdatePending);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 6]]);
      }));
      function _$ET() {
        return _$ET2.apply(this, arguments);
      }
      return _$ET;
    }()
  }, {
    key: "scheduleUpdate",
    value: function scheduleUpdate() {
      return this.performUpdate();
    }
  }, {
    key: "performUpdate",
    value: function performUpdate() {
      var e;
      if (!this.isUpdatePending) return;
      if (!this.hasUpdated) {
        if (this.renderRoot != null || (this.renderRoot = this.createRenderRoot()), this._$Ep) {
          var _iterator8 = _createForOfIteratorHelper(this._$Ep),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _step8$value = _slicedToArray(_step8.value, 2),
                s = _step8$value[0],
                a = _step8$value[1];
              this[s] = a;
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
          this._$Ep = void 0;
        }
        var n = this.constructor.elementProperties;
        if (n.size > 0) {
          var _iterator9 = _createForOfIteratorHelper(n),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var _step9$value = _slicedToArray(_step9.value, 2),
                _s = _step9$value[0],
                _a = _step9$value[1];
              _a.wrapped !== !0 || this._$AL.has(_s) || this[_s] === void 0 || this.P(_s, this[_s], _a);
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        }
      }
      var t = !1;
      var o = this._$AL;
      try {
        t = this.shouldUpdate(o), t ? (this.willUpdate(o), (e = this._$EO) == null || e.forEach(function (n) {
          var s;
          return (s = n.hostUpdate) == null ? void 0 : s.call(n);
        }), this.update(o)) : this._$EU();
      } catch (n) {
        throw t = !1, this._$EU(), n;
      }
      t && this._$AE(o);
    }
  }, {
    key: "willUpdate",
    value: function willUpdate(e) {}
  }, {
    key: "_$AE",
    value: function _$AE(e) {
      var t;
      (t = this._$EO) == null || t.forEach(function (o) {
        var n;
        return (n = o.hostUpdated) == null ? void 0 : n.call(o);
      }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
    }
  }, {
    key: "_$EU",
    value: function _$EU() {
      this._$AL = /* @__PURE__ */new Map(), this.isUpdatePending = !1;
    }
  }, {
    key: "getUpdateComplete",
    value: function getUpdateComplete() {
      return this._$ES;
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(e) {
      return !0;
    }
  }, {
    key: "update",
    value: function update(e) {
      var _this3 = this;
      this._$Ej && (this._$Ej = this._$Ej.forEach(function (t) {
        return _this3._$EC(t, _this3[t]);
      })), this._$EU();
    }
  }, {
    key: "updated",
    value: function updated(e) {}
  }, {
    key: "firstUpdated",
    value: function firstUpdated(e) {}
  }, {
    key: "updateComplete",
    get: function get() {
      return this.getUpdateComplete();
    }
  }]);
  return de;
}(_wrapNativeSuper(HTMLElement));
var tr;
de.elementStyles = [], de.shadowRootOptions = {
  mode: "open"
}, de[Se("elementProperties")] = /* @__PURE__ */new Map(), de[Se("finalized")] = /* @__PURE__ */new Map(), Jt == null || Jt({
  ReactiveElement: de
}), ((tr = me.reactiveElementVersions) != null ? tr : me.reactiveElementVersions = []).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var co = {
    attribute: !0,
    type: String,
    converter: Fe,
    reflect: !1,
    hasChanged: wt
  },
  ho = function ho() {
    var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : co;
    var e = arguments.length > 1 ? arguments[1] : undefined;
    var t = arguments.length > 2 ? arguments[2] : undefined;
    var o = t.kind,
      n = t.metadata;
    var s = globalThis.litPropertyMetadata.get(n);
    if (s === void 0 && globalThis.litPropertyMetadata.set(n, s = /* @__PURE__ */new Map()), s.set(t.name, r), o === "accessor") {
      var a = t.name;
      return {
        set: function set(c) {
          var h = e.get.call(this);
          e.set.call(this, c), this.requestUpdate(a, h, r);
        },
        init: function init(c) {
          return c !== void 0 && this.P(a, void 0, r), c;
        }
      };
    }
    if (o === "setter") {
      var _a2 = t.name;
      return function (c) {
        var h = this[_a2];
        e.call(this, c), this.requestUpdate(_a2, h, r);
      };
    }
    throw Error("Unsupported decorator location: " + o);
  };
function x(r) {
  return function (e, t) {
    return typeof t == "object" ? ho(r, e, t) : function (o, n, s) {
      var a = n.hasOwnProperty(s);
      return n.constructor.createProperty(s, a ? _objectSpread({}, o, {
        wrapped: !0
      }) : o), a ? Object.getOwnPropertyDescriptor(n, s) : void 0;
    }(r, e, t);
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var je = globalThis,
  ze = je.trustedTypes,
  rr = ze ? ze.createPolicy("lit-html", {
    createHTML: function createHTML(r) {
      return r;
    }
  }) : void 0,
  $t = "$lit$",
  G = "lit$".concat((Math.random() + "").slice(9), "$"),
  Rt = "?" + G,
  uo = "<".concat(Rt, ">"),
  te = document,
  we = function we() {
    return te.createComment("");
  },
  $e = function $e(r) {
    return r === null || typeof r != "object" && typeof r != "function";
  },
  Ar = Array.isArray,
  Sr = function Sr(r) {
    return Ar(r) || typeof (r == null ? void 0 : r[Symbol.iterator]) == "function";
  },
  ht = "[ \t\n\f\r]",
  _e = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,
  or = /-->/g,
  ir = />/g,
  Z = RegExp(">|".concat(ht, "(?:([^\\s\"'>=/]+)(").concat(ht, "*=").concat(ht, "*(?:[^ \t\n\f\r\"'`<>=]|(\"|')|))|$)"), "g"),
  nr = /'/g,
  ar = /"/g,
  wr = /^(?:script|style|textarea|title)$/i,
  po = function po(r) {
    return function (e) {
      for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        t[_key2 - 1] = arguments[_key2];
      }
      return {
        _$litType$: r,
        strings: e,
        values: t
      };
    };
  },
  mo = po(1),
  fe = Symbol.for("lit-noChange"),
  $ = Symbol.for("lit-nothing"),
  sr = /* @__PURE__ */new WeakMap(),
  J = te.createTreeWalker(te, 129);
function $r(r, e) {
  if (!Array.isArray(r) || !r.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return rr !== void 0 ? rr.createHTML(e) : e;
}
var Rr = function Rr(r, e) {
  var t = r.length - 1,
    o = [];
  var n,
    s = e === 2 ? "<svg>" : "",
    a = _e;
  for (var c = 0; c < t; c++) {
    var h = r[c];
    var u = void 0,
      m = void 0,
      f = -1,
      U = 0;
    for (; U < h.length && (a.lastIndex = U, m = a.exec(h), m !== null);) U = a.lastIndex, a === _e ? m[1] === "!--" ? a = or : m[1] !== void 0 ? a = ir : m[2] !== void 0 ? (wr.test(m[2]) && (n = RegExp("</" + m[2], "g")), a = Z) : m[3] !== void 0 && (a = Z) : a === Z ? m[0] === ">" ? (a = n != null ? n : _e, f = -1) : m[1] === void 0 ? f = -2 : (f = a.lastIndex - m[2].length, u = m[1], a = m[3] === void 0 ? Z : m[3] === '"' ? ar : nr) : a === ar || a === nr ? a = Z : a === or || a === ir ? a = _e : (a = Z, n = void 0);
    var C = a === Z && r[c + 1].startsWith("/>") ? " " : "";
    s += a === _e ? h + uo : f >= 0 ? (o.push(u), h.slice(0, f) + $t + h.slice(f) + G + C) : h + G + (f === -2 ? c : C);
  }
  return [$r(r, s + (r[t] || "<?>") + (e === 2 ? "</svg>" : "")), o];
};
var Re = /*#__PURE__*/function () {
  function Re(_ref2, o) {
    var e = _ref2.strings,
      t = _ref2._$litType$;
    _classCallCheck(this, Re);
    var n;
    this.parts = [];
    var s = 0,
      a = 0;
    var c = e.length - 1,
      h = this.parts,
      _Rr = Rr(e, t),
      _Rr2 = _slicedToArray(_Rr, 2),
      u = _Rr2[0],
      m = _Rr2[1];
    if (this.el = Re.createElement(u, o), J.currentNode = this.el.content, t === 2) {
      var f = this.el.content.firstChild;
      f.replaceWith.apply(f, _toConsumableArray(f.childNodes));
    }
    for (; (n = J.nextNode()) !== null && h.length < c;) {
      if (n.nodeType === 1) {
        if (n.hasAttributes()) {
          var _iterator10 = _createForOfIteratorHelper(n.getAttributeNames()),
            _step10;
          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var _f = _step10.value;
              if (_f.endsWith($t)) {
                var U = m[a++],
                  C = n.getAttribute(_f).split(G),
                  z = /([.?@])?(.*)/.exec(U);
                h.push({
                  type: 1,
                  index: s,
                  name: z[2],
                  strings: C,
                  ctor: z[1] === "." ? Nr : z[1] === "?" ? Tr : z[1] === "@" ? Cr : Oe
                }), n.removeAttribute(_f);
              } else _f.startsWith(G) && (h.push({
                type: 6,
                index: s
              }), n.removeAttribute(_f));
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
        }
        if (wr.test(n.tagName)) {
          var _f2 = n.textContent.split(G),
            _U = _f2.length - 1;
          if (_U > 0) {
            n.textContent = ze ? ze.emptyScript : "";
            for (var _C = 0; _C < _U; _C++) n.append(_f2[_C], we()), J.nextNode(), h.push({
              type: 2,
              index: ++s
            });
            n.append(_f2[_U], we());
          }
        }
      } else if (n.nodeType === 8) if (n.data === Rt) h.push({
        type: 2,
        index: s
      });else {
        var _f3 = -1;
        for (; (_f3 = n.data.indexOf(G, _f3 + 1)) !== -1;) h.push({
          type: 7,
          index: s
        }), _f3 += G.length - 1;
      }
      s++;
    }
  }
  _createClass(Re, null, [{
    key: "createElement",
    value: function createElement(e, t) {
      var o = te.createElement("template");
      return o.innerHTML = e, o;
    }
  }]);
  return Re;
}();
function re(r, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : r;
  var o = arguments.length > 3 ? arguments[3] : undefined;
  var n, s, a;
  if (e === fe) return e;
  var c = o !== void 0 ? (n = t._$Co) == null ? void 0 : n[o] : t._$Cl;
  var h = $e(e) ? void 0 : e._$litDirective$;
  return (c == null ? void 0 : c.constructor) !== h && ((s = c == null ? void 0 : c._$AO) == null || s.call(c, !1), h === void 0 ? c = void 0 : (c = new h(r), c._$AT(r, t, o)), o !== void 0 ? ((a = t._$Co) != null ? a : t._$Co = [])[o] = c : t._$Cl = c), c !== void 0 && (e = re(r, c._$AS(r, e.values), c, o)), e;
}
var Or = /*#__PURE__*/function () {
  function Or(e, t) {
    _classCallCheck(this, Or);
    this._$AV = [], this._$AN = void 0, this._$AD = e, this._$AM = t;
  }
  _createClass(Or, [{
    key: "u",
    value: function u(e) {
      var t;
      var _this$_$AD = this._$AD,
        o = _this$_$AD.el.content,
        n = _this$_$AD.parts,
        s = ((t = e == null ? void 0 : e.creationScope) != null ? t : te).importNode(o, !0);
      J.currentNode = s;
      var a = J.nextNode(),
        c = 0,
        h = 0,
        u = n[0];
      for (; u !== void 0;) {
        if (c === u.index) {
          var m = void 0;
          u.type === 2 ? m = new ve(a, a.nextSibling, this, e) : u.type === 1 ? m = new u.ctor(a, u.name, u.strings, this, e) : u.type === 6 && (m = new Dr(a, this, e)), this._$AV.push(m), u = n[++h];
        }
        c !== (u == null ? void 0 : u.index) && (a = J.nextNode(), c++);
      }
      return J.currentNode = te, s;
    }
  }, {
    key: "p",
    value: function p(e) {
      var t = 0;
      var _iterator11 = _createForOfIteratorHelper(this._$AV),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var o = _step11.value;
          o !== void 0 && (o.strings !== void 0 ? (o._$AI(e, o, t), t += o.strings.length - 2) : o._$AI(e[t])), t++;
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
  }, {
    key: "parentNode",
    get: function get() {
      return this._$AM.parentNode;
    }
  }, {
    key: "_$AU",
    get: function get() {
      return this._$AM._$AU;
    }
  }]);
  return Or;
}();
var ve = /*#__PURE__*/function () {
  _createClass(ve, [{
    key: "_$AU",
    get: function get() {
      var e, t;
      return (t = (e = this._$AM) == null ? void 0 : e._$AU) != null ? t : this._$Cv;
    }
  }]);
  function ve(e, t, o, n) {
    _classCallCheck(this, ve);
    var s;
    this.type = 2, this._$AH = $, this._$AN = void 0, this._$AA = e, this._$AB = t, this._$AM = o, this.options = n, this._$Cv = (s = n == null ? void 0 : n.isConnected) != null ? s : !0;
  }
  _createClass(ve, [{
    key: "_$AI",
    value: function _$AI(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      e = re(this, e, t), $e(e) ? e === $ || e == null || e === "" ? (this._$AH !== $ && this._$AR(), this._$AH = $) : e !== this._$AH && e !== fe && this._(e) : e._$litType$ !== void 0 ? this.$(e) : e.nodeType !== void 0 ? this.T(e) : Sr(e) ? this.k(e) : this._(e);
    }
  }, {
    key: "S",
    value: function S(e) {
      return this._$AA.parentNode.insertBefore(e, this._$AB);
    }
  }, {
    key: "T",
    value: function T(e) {
      this._$AH !== e && (this._$AR(), this._$AH = this.S(e));
    }
  }, {
    key: "_",
    value: function _(e) {
      this._$AH !== $ && $e(this._$AH) ? this._$AA.nextSibling.data = e : this.T(te.createTextNode(e)), this._$AH = e;
    }
  }, {
    key: "$",
    value: function $(e) {
      var t;
      var o = e.values,
        n = e._$litType$,
        s = typeof n == "number" ? this._$AC(e) : (n.el === void 0 && (n.el = Re.createElement($r(n.h, n.h[0]), this.options)), n);
      if (((t = this._$AH) == null ? void 0 : t._$AD) === s) this._$AH.p(o);else {
        var a = new Or(s, this),
          c = a.u(this.options);
        a.p(o), this.T(c), this._$AH = a;
      }
    }
  }, {
    key: "_$AC",
    value: function _$AC(e) {
      var t = sr.get(e.strings);
      return t === void 0 && sr.set(e.strings, t = new Re(e)), t;
    }
  }, {
    key: "k",
    value: function k(e) {
      Ar(this._$AH) || (this._$AH = [], this._$AR());
      var t = this._$AH;
      var o,
        n = 0;
      var _iterator12 = _createForOfIteratorHelper(e),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var s = _step12.value;
          n === t.length ? t.push(o = new ve(this.S(we()), this.S(we()), this, this.options)) : o = t[n], o._$AI(s), n++;
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      n < t.length && (this._$AR(o && o._$AB.nextSibling, n), t.length = n);
    }
  }, {
    key: "_$AR",
    value: function _$AR() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._$AA.nextSibling;
      var t = arguments.length > 1 ? arguments[1] : undefined;
      var o;
      for ((o = this._$AP) == null ? void 0 : o.call(this, !1, !0, t); e && e !== this._$AB;) {
        var n = e.nextSibling;
        e.remove(), e = n;
      }
    }
  }, {
    key: "setConnected",
    value: function setConnected(e) {
      var t;
      this._$AM === void 0 && (this._$Cv = e, (t = this._$AP) == null || t.call(this, e));
    }
  }, {
    key: "parentNode",
    get: function get() {
      var e = this._$AA.parentNode;
      var t = this._$AM;
      return t !== void 0 && (e == null ? void 0 : e.nodeType) === 11 && (e = t.parentNode), e;
    }
  }, {
    key: "startNode",
    get: function get() {
      return this._$AA;
    }
  }, {
    key: "endNode",
    get: function get() {
      return this._$AB;
    }
  }]);
  return ve;
}();
var Oe = /*#__PURE__*/function () {
  _createClass(Oe, [{
    key: "tagName",
    get: function get() {
      return this.element.tagName;
    }
  }, {
    key: "_$AU",
    get: function get() {
      return this._$AM._$AU;
    }
  }]);
  function Oe(e, t, o, n, s) {
    _classCallCheck(this, Oe);
    this.type = 1, this._$AH = $, this._$AN = void 0, this.element = e, this.name = t, this._$AM = n, this.options = s, o.length > 2 || o[0] !== "" || o[1] !== "" ? (this._$AH = Array(o.length - 1).fill(new String()), this.strings = o) : this._$AH = $;
  }
  _createClass(Oe, [{
    key: "_$AI",
    value: function _$AI(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var o = arguments.length > 2 ? arguments[2] : undefined;
      var n = arguments.length > 3 ? arguments[3] : undefined;
      var s = this.strings;
      var a = !1;
      if (s === void 0) e = re(this, e, t, 0), a = !$e(e) || e !== this._$AH && e !== fe, a && (this._$AH = e);else {
        var c = e;
        var h, u;
        for (e = s[0], h = 0; h < s.length - 1; h++) u = re(this, c[o + h], t, h), u === fe && (u = this._$AH[h]), a || (a = !$e(u) || u !== this._$AH[h]), u === $ ? e = $ : e !== $ && (e += (u != null ? u : "") + s[h + 1]), this._$AH[h] = u;
      }
      a && !n && this.j(e);
    }
  }, {
    key: "j",
    value: function j(e) {
      e === $ ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e != null ? e : "");
    }
  }]);
  return Oe;
}();
var Nr = /*#__PURE__*/function (_Oe) {
  _inherits(Nr, _Oe);
  function Nr() {
    var _this4;
    _classCallCheck(this, Nr);
    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(Nr).apply(this, arguments)), _this4.type = 3;
    return _this4;
  }
  _createClass(Nr, [{
    key: "j",
    value: function j(e) {
      this.element[this.name] = e === $ ? void 0 : e;
    }
  }]);
  return Nr;
}(Oe);
var Tr = /*#__PURE__*/function (_Oe2) {
  _inherits(Tr, _Oe2);
  function Tr() {
    var _this5;
    _classCallCheck(this, Tr);
    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(Tr).apply(this, arguments)), _this5.type = 4;
    return _this5;
  }
  _createClass(Tr, [{
    key: "j",
    value: function j(e) {
      this.element.toggleAttribute(this.name, !!e && e !== $);
    }
  }]);
  return Tr;
}(Oe);
var Cr = /*#__PURE__*/function (_Oe3) {
  _inherits(Cr, _Oe3);
  function Cr(e, t, o, n, s) {
    var _this6;
    _classCallCheck(this, Cr);
    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(Cr).call(this, e, t, o, n, s)), _this6.type = 5;
    return _this6;
  }
  _createClass(Cr, [{
    key: "_$AI",
    value: function _$AI(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var o;
      if ((e = (o = re(this, e, t, 0)) != null ? o : $) === fe) return;
      var n = this._$AH,
        s = e === $ && n !== $ || e.capture !== n.capture || e.once !== n.once || e.passive !== n.passive,
        a = e !== $ && (n === $ || s);
      s && this.element.removeEventListener(this.name, this, n), a && this.element.addEventListener(this.name, this, e), this._$AH = e;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      var t, o;
      typeof this._$AH == "function" ? this._$AH.call((o = (t = this.options) == null ? void 0 : t.host) != null ? o : this.element, e) : this._$AH.handleEvent(e);
    }
  }]);
  return Cr;
}(Oe);
var Dr = /*#__PURE__*/function () {
  function Dr(e, t, o) {
    _classCallCheck(this, Dr);
    this.element = e, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = o;
  }
  _createClass(Dr, [{
    key: "_$AI",
    value: function _$AI(e) {
      re(this, e);
    }
  }, {
    key: "_$AU",
    get: function get() {
      return this._$AM._$AU;
    }
  }]);
  return Dr;
}();
var ii = {
    P: $t,
    A: G,
    C: Rt,
    M: 1,
    L: Rr,
    R: Or,
    D: Sr,
    V: re,
    I: ve,
    H: Oe,
    N: Tr,
    U: Cr,
    B: Nr,
    F: Dr
  },
  lr = je.litHtmlPolyfillSupport;
var cr;
lr == null || lr(Re, ve), ((cr = je.litHtmlVersions) != null ? cr : je.litHtmlVersions = []).push("3.1.2");
var fo = function fo(r, e, t) {
  var o, n;
  var s = (o = t == null ? void 0 : t.renderBefore) != null ? o : e;
  var a = s._$litPart$;
  if (a === void 0) {
    var c = (n = t == null ? void 0 : t.renderBefore) != null ? n : null;
    s._$litPart$ = a = new ve(e.insertBefore(we(), c), c, void 0, t != null ? t : {});
  }
  return a._$AI(r), a;
};
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var xr = Symbol.for(""),
  vo = function vo(r) {
    if ((r == null ? void 0 : r.r) === xr) return r == null ? void 0 : r._$litStatic$;
  },
  bo = function bo(r) {
    return {
      _$litStatic$: r,
      r: xr
    };
  },
  dr = /* @__PURE__ */new Map(),
  go = function go(r) {
    return function (e) {
      for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        t[_key3 - 1] = arguments[_key3];
      }
      var o = t.length;
      var n, s;
      var a = [],
        c = [];
      var h,
        u = 0,
        m = !1;
      for (; u < o;) {
        for (h = e[u]; u < o && (s = t[u], (n = vo(s)) !== void 0);) h += n + e[++u], m = !0;
        u !== o && c.push(s), a.push(h), u++;
      }
      if (u === o && a.push(e[o]), m) {
        var f = a.join("$$lit$$");
        (e = dr.get(f)) === void 0 && (a.raw = a, dr.set(f, e = a)), t = c;
      }
      return r.apply(void 0, [e].concat(_toConsumableArray(t)));
    };
  },
  ni = go(mo);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var pe = /*#__PURE__*/function (_de) {
  _inherits(pe, _de);
  function pe() {
    var _this7;
    _classCallCheck(this, pe);
    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(pe).apply(this, arguments)), _this7.renderOptions = {
      host: _assertThisInitialized(_assertThisInitialized(_this7))
    }, _this7._$Do = void 0;
    return _this7;
  }
  _createClass(pe, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      var e;
      var t = _get(_getPrototypeOf(pe.prototype), "createRenderRoot", this).call(this);
      return (e = this.renderOptions).renderBefore != null || (e.renderBefore = t.firstChild), t;
    }
  }, {
    key: "update",
    value: function update(e) {
      var t = this.render();
      this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), _get(_getPrototypeOf(pe.prototype), "update", this).call(this, e), this._$Do = fo(t, this.renderRoot, this.renderOptions);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var e;
      _get(_getPrototypeOf(pe.prototype), "connectedCallback", this).call(this), (e = this._$Do) == null || e.setConnected(!0);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var e;
      _get(_getPrototypeOf(pe.prototype), "disconnectedCallback", this).call(this), (e = this._$Do) == null || e.setConnected(!1);
    }
  }, {
    key: "render",
    value: function render() {
      return fe;
    }
  }]);
  return pe;
}(de);
var hr;
pe._$litElement$ = !0, pe.finalized = !0, (hr = globalThis.litElementHydrateSupport) == null || hr.call(globalThis, {
  LitElement: pe
});
var ur = globalThis.litElementPolyfillSupport;
ur == null || ur({
  LitElement: pe
});
var pr;
((pr = globalThis.litElementVersions) != null ? pr : globalThis.litElementVersions = []).push("4.0.4");
function ai(r) {
  for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    e[_key4 - 1] = arguments[_key4];
  }
  return e.reduce(function (t, o) {
    return o(t);
  }, r);
}
/*! @license DOMPurify 2.4.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.7/LICENSE */
function K(r) {
  "@babel/helpers - typeof";

  return K = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (e) {
    return typeof e;
  } : function (e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, K(r);
}
function yt(r, e) {
  return yt = Object.setPrototypeOf || function (t, o) {
    return t.__proto__ = o, t;
  }, yt(r, e);
}
function yo() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused2) {
    return !1;
  }
}
function Ue(r, e, t) {
  return yo() ? Ue = Reflect.construct : Ue = function Ue(o, n, s) {
    var a = [null];
    a.push.apply(a, n);
    var c = Function.bind.apply(o, a),
      h = new c();
    return s && yt(h, s.prototype), h;
  }, Ue.apply(null, arguments);
}
function B(r) {
  return Eo(r) || _o(r) || Ao(r) || So();
}
function Eo(r) {
  if (Array.isArray(r)) return Et(r);
}
function _o(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
}
function Ao(r, e) {
  if (r) {
    if (typeof r == "string") return Et(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set") return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Et(r, e);
  }
}
function Et(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, o = new Array(e); t < e; t++) o[t] = r[t];
  return o;
}
function So() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var wo = Object.hasOwnProperty,
  mr = Object.setPrototypeOf,
  $o = Object.isFrozen,
  Ro = Object.getPrototypeOf,
  Oo = Object.getOwnPropertyDescriptor,
  O = Object.freeze,
  F = Object.seal,
  No = Object.create,
  Mr = typeof Reflect < "u" && Reflect,
  We = Mr.apply,
  _t = Mr.construct;
We || (We = function We(r, e, t) {
  return r.apply(e, t);
});
O || (O = function O(r) {
  return r;
});
F || (F = function F(r) {
  return r;
});
_t || (_t = function _t(r, e) {
  return Ue(r, B(e));
});
var To = P(Array.prototype.forEach),
  fr = P(Array.prototype.pop),
  Ae = P(Array.prototype.push),
  Ie = P(String.prototype.toLowerCase),
  ut = P(String.prototype.toString),
  Co = P(String.prototype.match),
  H = P(String.prototype.replace),
  Do = P(String.prototype.indexOf),
  xo = P(String.prototype.trim),
  R = P(RegExp.prototype.test),
  pt = Mo(TypeError);
function P(r) {
  return function (e) {
    for (var t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) o[n - 1] = arguments[n];
    return We(r, e, o);
  };
}
function Mo(r) {
  return function () {
    for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++) t[o] = arguments[o];
    return _t(r, t);
  };
}
function p(r, e, t) {
  var o;
  t = (o = t) !== null && o !== void 0 ? o : Ie, mr && mr(r, null);
  for (var n = e.length; n--;) {
    var s = e[n];
    if (typeof s == "string") {
      var a = t(s);
      a !== s && ($o(e) || (e[n] = a), s = a);
    }
    r[s] = !0;
  }
  return r;
}
function X(r) {
  var e = No(null),
    t;
  for (t in r) We(wo, r, [t]) === !0 && (e[t] = r[t]);
  return e;
}
function Le(r, e) {
  for (; r !== null;) {
    var t = Oo(r, e);
    if (t) {
      if (t.get) return P(t.get);
      if (typeof t.value == "function") return P(t.value);
    }
    r = Ro(r);
  }
  function o(n) {
    return console.warn("fallback value for", n), null;
  }
  return o;
}
var vr = O(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
  mt = O(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
  ft = O(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
  Lo = O(["animate", "color-profile", "cursor", "discard", "fedropshadow", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
  vt = O(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"]),
  ko = O(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
  br = O(["#text"]),
  gr = O(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]),
  bt = O(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
  yr = O(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
  ke = O(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
  Po = F(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
  Uo = F(/<%[\w\W]*|[\w\W]*%>/gm),
  Io = F(/\${[\w\W]*}/gm),
  Ho = F(/^data-[\-\w.\u00B7-\uFFFF]/),
  Bo = F(/^aria-[\-\w]+$/),
  Fo = F(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
  ),
  jo = F(/^(?:\w+script|data):/i),
  zo = F(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
  ),
  Wo = F(/^html$/i),
  qo = function qo() {
    return typeof window > "u" ? null : window;
  },
  Vo = function Vo(r, e) {
    if (K(r) !== "object" || typeof r.createPolicy != "function") return null;
    var t = null,
      o = "data-tt-policy-suffix";
    e.currentScript && e.currentScript.hasAttribute(o) && (t = e.currentScript.getAttribute(o));
    var n = "dompurify" + (t ? "#" + t : "");
    try {
      return r.createPolicy(n, {
        createHTML: function createHTML(s) {
          return s;
        },
        createScriptURL: function createScriptURL(s) {
          return s;
        }
      });
    } catch (_unused3) {
      return console.warn("TrustedTypes policy " + n + " could not be created."), null;
    }
  };
function Lr() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : qo(),
    e = function e(i) {
      return Lr(i);
    };
  if (e.version = "2.4.7", e.removed = [], !r || !r.document || r.document.nodeType !== 9) return e.isSupported = !1, e;
  var t = r.document,
    o = r.document,
    n = r.DocumentFragment,
    s = r.HTMLTemplateElement,
    a = r.Node,
    c = r.Element,
    h = r.NodeFilter,
    u = r.NamedNodeMap,
    m = u === void 0 ? r.NamedNodeMap || r.MozNamedAttrMap : u,
    f = r.HTMLFormElement,
    U = r.DOMParser,
    C = r.trustedTypes,
    z = c.prototype,
    kr = Le(z, "cloneNode"),
    Pr = Le(z, "nextSibling"),
    Ur = Le(z, "childNodes"),
    Ve = Le(z, "parentNode");
  if (typeof s == "function") {
    var Ge = o.createElement("template");
    Ge.content && Ge.content.ownerDocument && (o = Ge.content.ownerDocument);
  }
  var I = Vo(C, t),
    Ke = I ? I.createHTML("") : "",
    Ne = o,
    Ye = Ne.implementation,
    Ir = Ne.createNodeIterator,
    Hr = Ne.createDocumentFragment,
    Br = Ne.getElementsByTagName,
    Fr = t.importNode,
    Ot = {};
  try {
    Ot = X(o).documentMode ? o.documentMode : {};
  } catch (_unused4) {}
  var j = {};
  e.isSupported = typeof Ve == "function" && Ye && Ye.createHTMLDocument !== void 0 && Ot !== 9;
  var Qe = Po,
    Ze = Uo,
    Xe = Io,
    jr = Ho,
    zr = Bo,
    Wr = jo,
    Nt = zo,
    Je = Fo,
    _ = null,
    Tt = p({}, [].concat(B(vr), B(mt), B(ft), B(vt), B(br))),
    A = null,
    Ct = p({}, [].concat(B(gr), B(bt), B(yr), B(ke))),
    g = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: null
      },
      attributeNameCheck: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: !1
      }
    })),
    be = null,
    et = null,
    Dt = !0,
    tt = !0,
    xt = !1,
    Mt = !0,
    oe = !1,
    Y = !1,
    rt = !1,
    ot = !1,
    ie = !1,
    Te = !1,
    Ce = !1,
    Lt = !0,
    kt = !1,
    qr = "user-content-",
    it = !0,
    ge = !1,
    ne = {},
    ae = null,
    Pt = p({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]),
    Ut = null,
    It = p({}, ["audio", "video", "img", "source", "image", "track"]),
    nt = null,
    Ht = p({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
    De = "http://www.w3.org/1998/Math/MathML",
    xe = "http://www.w3.org/2000/svg",
    W = "http://www.w3.org/1999/xhtml",
    se = W,
    at = !1,
    st = null,
    Vr = p({}, [De, xe, W], ut),
    Q,
    Gr = ["application/xhtml+xml", "text/html"],
    Kr = "text/html",
    S,
    le = null,
    Yr = o.createElement("form"),
    Bt = function Bt(i) {
      return i instanceof RegExp || i instanceof Function;
    },
    lt = function lt(i) {
      le && le === i || ((!i || K(i) !== "object") && (i = {}), i = X(i), Q =
      // eslint-disable-next-line unicorn/prefer-includes
      Gr.indexOf(i.PARSER_MEDIA_TYPE) === -1 ? Q = Kr : Q = i.PARSER_MEDIA_TYPE, S = Q === "application/xhtml+xml" ? ut : Ie, _ = "ALLOWED_TAGS" in i ? p({}, i.ALLOWED_TAGS, S) : Tt, A = "ALLOWED_ATTR" in i ? p({}, i.ALLOWED_ATTR, S) : Ct, st = "ALLOWED_NAMESPACES" in i ? p({}, i.ALLOWED_NAMESPACES, ut) : Vr, nt = "ADD_URI_SAFE_ATTR" in i ? p(X(Ht),
      // eslint-disable-line indent
      i.ADD_URI_SAFE_ATTR,
      // eslint-disable-line indent
      S
      // eslint-disable-line indent
      ) : Ht, Ut = "ADD_DATA_URI_TAGS" in i ? p(X(It),
      // eslint-disable-line indent
      i.ADD_DATA_URI_TAGS,
      // eslint-disable-line indent
      S
      // eslint-disable-line indent
      ) : It, ae = "FORBID_CONTENTS" in i ? p({}, i.FORBID_CONTENTS, S) : Pt, be = "FORBID_TAGS" in i ? p({}, i.FORBID_TAGS, S) : {}, et = "FORBID_ATTR" in i ? p({}, i.FORBID_ATTR, S) : {}, ne = "USE_PROFILES" in i ? i.USE_PROFILES : !1, Dt = i.ALLOW_ARIA_ATTR !== !1, tt = i.ALLOW_DATA_ATTR !== !1, xt = i.ALLOW_UNKNOWN_PROTOCOLS || !1, Mt = i.ALLOW_SELF_CLOSE_IN_ATTR !== !1, oe = i.SAFE_FOR_TEMPLATES || !1, Y = i.WHOLE_DOCUMENT || !1, ie = i.RETURN_DOM || !1, Te = i.RETURN_DOM_FRAGMENT || !1, Ce = i.RETURN_TRUSTED_TYPE || !1, ot = i.FORCE_BODY || !1, Lt = i.SANITIZE_DOM !== !1, kt = i.SANITIZE_NAMED_PROPS || !1, it = i.KEEP_CONTENT !== !1, ge = i.IN_PLACE || !1, Je = i.ALLOWED_URI_REGEXP || Je, se = i.NAMESPACE || W, g = i.CUSTOM_ELEMENT_HANDLING || {}, i.CUSTOM_ELEMENT_HANDLING && Bt(i.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (g.tagNameCheck = i.CUSTOM_ELEMENT_HANDLING.tagNameCheck), i.CUSTOM_ELEMENT_HANDLING && Bt(i.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (g.attributeNameCheck = i.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), i.CUSTOM_ELEMENT_HANDLING && typeof i.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (g.allowCustomizedBuiltInElements = i.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), oe && (tt = !1), Te && (ie = !0), ne && (_ = p({}, B(br)), A = [], ne.html === !0 && (p(_, vr), p(A, gr)), ne.svg === !0 && (p(_, mt), p(A, bt), p(A, ke)), ne.svgFilters === !0 && (p(_, ft), p(A, bt), p(A, ke)), ne.mathMl === !0 && (p(_, vt), p(A, yr), p(A, ke))), i.ADD_TAGS && (_ === Tt && (_ = X(_)), p(_, i.ADD_TAGS, S)), i.ADD_ATTR && (A === Ct && (A = X(A)), p(A, i.ADD_ATTR, S)), i.ADD_URI_SAFE_ATTR && p(nt, i.ADD_URI_SAFE_ATTR, S), i.FORBID_CONTENTS && (ae === Pt && (ae = X(ae)), p(ae, i.FORBID_CONTENTS, S)), it && (_["#text"] = !0), Y && p(_, ["html", "head", "body"]), _.table && (p(_, ["tbody"]), delete be.tbody), O && O(i), le = i);
    },
    Ft = p({}, ["mi", "mo", "mn", "ms", "mtext"]),
    jt = p({}, ["foreignobject", "desc", "title", "annotation-xml"]),
    Qr = p({}, ["title", "style", "font", "a", "script"]),
    Me = p({}, mt);
  p(Me, ft), p(Me, Lo);
  var ct = p({}, vt);
  p(ct, ko);
  var Zr = function Zr(i) {
      var d = Ve(i);
      (!d || !d.tagName) && (d = {
        namespaceURI: se,
        tagName: "template"
      });
      var l = Ie(i.tagName),
        v = Ie(d.tagName);
      return st[i.namespaceURI] ? i.namespaceURI === xe ? d.namespaceURI === W ? l === "svg" : d.namespaceURI === De ? l === "svg" && (v === "annotation-xml" || Ft[v]) : !!Me[l] : i.namespaceURI === De ? d.namespaceURI === W ? l === "math" : d.namespaceURI === xe ? l === "math" && jt[v] : !!ct[l] : i.namespaceURI === W ? d.namespaceURI === xe && !jt[v] || d.namespaceURI === De && !Ft[v] ? !1 : !ct[l] && (Qr[l] || !Me[l]) : !!(Q === "application/xhtml+xml" && st[i.namespaceURI]) : !1;
    },
    ce = function ce(i) {
      Ae(e.removed, {
        element: i
      });
      try {
        i.parentNode.removeChild(i);
      } catch (_unused5) {
        try {
          i.outerHTML = Ke;
        } catch (_unused6) {
          i.remove();
        }
      }
    },
    dt = function dt(i, d) {
      try {
        Ae(e.removed, {
          attribute: d.getAttributeNode(i),
          from: d
        });
      } catch (_unused7) {
        Ae(e.removed, {
          attribute: null,
          from: d
        });
      }
      if (d.removeAttribute(i), i === "is" && !A[i]) if (ie || Te) try {
        ce(d);
      } catch (_unused8) {} else try {
        d.setAttribute(i, "");
      } catch (_unused9) {}
    },
    zt = function zt(i) {
      var d, l;
      if (ot) i = "<remove></remove>" + i;else {
        var v = Co(i, /^[\r\n\t ]+/);
        l = v && v[0];
      }
      Q === "application/xhtml+xml" && se === W && (i = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + i + "</body></html>");
      var y = I ? I.createHTML(i) : i;
      if (se === W) try {
        d = new U().parseFromString(y, Q);
      } catch (_unused10) {}
      if (!d || !d.documentElement) {
        d = Ye.createDocument(se, "template", null);
        try {
          d.documentElement.innerHTML = at ? Ke : y;
        } catch (_unused11) {}
      }
      var D = d.body || d.documentElement;
      return i && l && D.insertBefore(o.createTextNode(l), D.childNodes[0] || null), se === W ? Br.call(d, Y ? "html" : "body")[0] : Y ? d.documentElement : D;
    },
    Wt = function Wt(i) {
      return Ir.call(i.ownerDocument || i, i,
      // eslint-disable-next-line no-bitwise
      h.SHOW_ELEMENT | h.SHOW_COMMENT | h.SHOW_TEXT, null, !1);
    },
    Xr = function Xr(i) {
      return i instanceof f && (typeof i.nodeName != "string" || typeof i.textContent != "string" || typeof i.removeChild != "function" || !(i.attributes instanceof m) || typeof i.removeAttribute != "function" || typeof i.setAttribute != "function" || typeof i.namespaceURI != "string" || typeof i.insertBefore != "function" || typeof i.hasChildNodes != "function");
    },
    ye = function ye(i) {
      return K(a) === "object" ? i instanceof a : i && K(i) === "object" && typeof i.nodeType == "number" && typeof i.nodeName == "string";
    },
    q = function q(i, d, l) {
      j[i] && To(j[i], function (v) {
        v.call(e, d, l, le);
      });
    },
    qt = function qt(i) {
      var d;
      if (q("beforeSanitizeElements", i, null), Xr(i) || R(/[\u0080-\uFFFF]/, i.nodeName)) return ce(i), !0;
      var l = S(i.nodeName);
      if (q("uponSanitizeElement", i, {
        tagName: l,
        allowedTags: _
      }), i.hasChildNodes() && !ye(i.firstElementChild) && (!ye(i.content) || !ye(i.content.firstElementChild)) && R(/<[/\w]/g, i.innerHTML) && R(/<[/\w]/g, i.textContent) || l === "select" && R(/<template/i, i.innerHTML)) return ce(i), !0;
      if (!_[l] || be[l]) {
        if (!be[l] && Gt(l) && (g.tagNameCheck instanceof RegExp && R(g.tagNameCheck, l) || g.tagNameCheck instanceof Function && g.tagNameCheck(l))) return !1;
        if (it && !ae[l]) {
          var v = Ve(i) || i.parentNode,
            y = Ur(i) || i.childNodes;
          if (y && v) for (var D = y.length, E = D - 1; E >= 0; --E) v.insertBefore(kr(y[E], !0), Pr(i));
        }
        return ce(i), !0;
      }
      return i instanceof c && !Zr(i) || (l === "noscript" || l === "noembed" || l === "noframes") && R(/<\/no(script|embed|frames)/i, i.innerHTML) ? (ce(i), !0) : (oe && i.nodeType === 3 && (d = i.textContent, d = H(d, Qe, " "), d = H(d, Ze, " "), d = H(d, Xe, " "), i.textContent !== d && (Ae(e.removed, {
        element: i.cloneNode()
      }), i.textContent = d)), q("afterSanitizeElements", i, null), !1);
    },
    Vt = function Vt(i, d, l) {
      if (Lt && (d === "id" || d === "name") && (l in o || l in Yr)) return !1;
      if (!(tt && !et[d] && R(jr, d)) && !(Dt && R(zr, d))) {
        if (!A[d] || et[d]) {
          if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(Gt(i) && (g.tagNameCheck instanceof RegExp && R(g.tagNameCheck, i) || g.tagNameCheck instanceof Function && g.tagNameCheck(i)) && (g.attributeNameCheck instanceof RegExp && R(g.attributeNameCheck, d) || g.attributeNameCheck instanceof Function && g.attributeNameCheck(d)) ||
          // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          d === "is" && g.allowCustomizedBuiltInElements && (g.tagNameCheck instanceof RegExp && R(g.tagNameCheck, l) || g.tagNameCheck instanceof Function && g.tagNameCheck(l)))) return !1;
        } else if (!nt[d] && !R(Je, H(l, Nt, "")) && !((d === "src" || d === "xlink:href" || d === "href") && i !== "script" && Do(l, "data:") === 0 && Ut[i]) && !(xt && !R(Wr, H(l, Nt, ""))) && l) return !1;
      }
      return !0;
    },
    Gt = function Gt(i) {
      return i.indexOf("-") > 0;
    },
    Kt = function Kt(i) {
      var d, l, v, y;
      q("beforeSanitizeAttributes", i, null);
      var D = i.attributes;
      if (D) {
        var E = {
          attrName: "",
          attrValue: "",
          keepAttr: !0,
          allowedAttributes: A
        };
        for (y = D.length; y--;) {
          d = D[y];
          var Ee = d,
            V = Ee.name,
            N = Ee.namespaceURI;
          if (l = V === "value" ? d.value : xo(d.value), v = S(V), E.attrName = v, E.attrValue = l, E.keepAttr = !0, E.forceKeepAttr = void 0, q("uponSanitizeAttribute", i, E), l = E.attrValue, !E.forceKeepAttr && (dt(V, i), !!E.keepAttr)) {
            if (!Mt && R(/\/>/i, l)) {
              dt(V, i);
              continue;
            }
            oe && (l = H(l, Qe, " "), l = H(l, Ze, " "), l = H(l, Xe, " "));
            var Yt = S(i.nodeName);
            if (Vt(Yt, v, l)) {
              if (kt && (v === "id" || v === "name") && (dt(V, i), l = qr + l), I && K(C) === "object" && typeof C.getAttributeType == "function" && !N) switch (C.getAttributeType(Yt, v)) {
                case "TrustedHTML":
                  {
                    l = I.createHTML(l);
                    break;
                  }
                case "TrustedScriptURL":
                  {
                    l = I.createScriptURL(l);
                    break;
                  }
              }
              try {
                N ? i.setAttributeNS(N, V, l) : i.setAttribute(V, l), fr(e.removed);
              } catch (_unused12) {}
            }
          }
        }
        q("afterSanitizeAttributes", i, null);
      }
    },
    Jr = function i(d) {
      var l,
        v = Wt(d);
      for (q("beforeSanitizeShadowDOM", d, null); l = v.nextNode();) q("uponSanitizeShadowNode", l, null), !qt(l) && (l.content instanceof n && i(l.content), Kt(l));
      q("afterSanitizeShadowDOM", d, null);
    };
  return e.sanitize = function (i) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      l,
      v,
      y,
      D,
      E;
    if (at = !i, at && (i = "<!-->"), typeof i != "string" && !ye(i)) if (typeof i.toString == "function") {
      if (i = i.toString(), typeof i != "string") throw pt("dirty is not a string, aborting");
    } else throw pt("toString is not a function");
    if (!e.isSupported) {
      if (K(r.toStaticHTML) === "object" || typeof r.toStaticHTML == "function") {
        if (typeof i == "string") return r.toStaticHTML(i);
        if (ye(i)) return r.toStaticHTML(i.outerHTML);
      }
      return i;
    }
    if (rt || lt(d), e.removed = [], typeof i == "string" && (ge = !1), ge) {
      if (i.nodeName) {
        var Ee = S(i.nodeName);
        if (!_[Ee] || be[Ee]) throw pt("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (i instanceof a) l = zt("<!---->"), v = l.ownerDocument.importNode(i, !0), v.nodeType === 1 && v.nodeName === "BODY" || v.nodeName === "HTML" ? l = v : l.appendChild(v);else {
      if (!ie && !oe && !Y &&
      // eslint-disable-next-line unicorn/prefer-includes
      i.indexOf("<") === -1) return I && Ce ? I.createHTML(i) : i;
      if (l = zt(i), !l) return ie ? null : Ce ? Ke : "";
    }
    l && ot && ce(l.firstChild);
    for (var V = Wt(ge ? i : l); y = V.nextNode();) y.nodeType === 3 && y === D || qt(y) || (y.content instanceof n && Jr(y.content), Kt(y), D = y);
    if (D = null, ge) return i;
    if (ie) {
      if (Te) for (E = Hr.call(l.ownerDocument); l.firstChild;) E.appendChild(l.firstChild);else E = l;
      return (A.shadowroot || A.shadowrootmod) && (E = Fr.call(t, E, !0)), E;
    }
    var N = Y ? l.outerHTML : l.innerHTML;
    return Y && _["!doctype"] && l.ownerDocument && l.ownerDocument.doctype && l.ownerDocument.doctype.name && R(Wo, l.ownerDocument.doctype.name) && (N = "<!DOCTYPE " + l.ownerDocument.doctype.name + ">\n" + N), oe && (N = H(N, Qe, " "), N = H(N, Ze, " "), N = H(N, Xe, " ")), I && Ce ? I.createHTML(N) : N;
  }, e.setConfig = function (i) {
    lt(i), rt = !0;
  }, e.clearConfig = function () {
    le = null, rt = !1;
  }, e.isValidAttribute = function (i, d, l) {
    le || lt({});
    var v = S(i),
      y = S(d);
    return Vt(v, y, l);
  }, e.addHook = function (i, d) {
    typeof d == "function" && (j[i] = j[i] || [], Ae(j[i], d));
  }, e.removeHook = function (i) {
    if (j[i]) return fr(j[i]);
  }, e.removeHooks = function (i) {
    j[i] && (j[i] = []);
  }, e.removeAllHooks = function () {
    j = {};
  }, e;
}
var Go = Lr(),
  He = /* @__PURE__ */function (r) {
    return r.NO_SYNC = "no-sync", r;
  }(He || {}),
  Be = /* @__PURE__ */function (r) {
    return r.VISIBLE = "visible", r.IDLE = "idle", r.INTERACTION = "interaction", r.MEDIA = "media", r.DEFINED = "defined", r;
  }(Be || {}),
  he = /* @__PURE__ */function (r) {
    return r.WARN = "warn", r.ERROR = "error", r.BROWSER = "browser", r.OFF = "off", r;
  }(he || {}),
  k = /* @__PURE__ */function (r) {
    return r.REQUIRED_SLOT_ERROR = "validate-req-slot-error", r.MAX_SLOT_ERROR = "validate-slot-children-max-error", r.MIN_SLOT_ERROR = "validate-slot-children-min-error", r.UNEQUAL_SLOT_ERROR = "validate-slotted-item-lengths-unequal-error", r.REQUIRED_PROP_ERROR = "validate-prop-error", r.REQUIRED_DEFAULT_SLOT_ERROR = "validate-req-default-slot-error", r;
  }(k || {}),
  w = /* @__PURE__ */function (r) {
    return r.BLUR = "beacon-event-blur", r.CHANGE = "beacon-event-change", r.CLICK = "beacon-event-click", r.FOCUS = "beacon-event-focus", r.HIDE = "beacon-event-hide", r.INPUT = "beacon-event-input", r.KEYDOWN = "beacon-event-keydown", r.MOUSEDOWN = "beacon-event-mousedown", r.MOUSEENTER = "beacon-event-mouseenter", r.MOUSELEAVE = "beacon-event-mouseleave", r.RENDER = "beacon-event-render", r.SORT = "beacon-event-sort", r.DEFERRED_CHILD = "beacon-event-deferred-child", r.RENDER_ACTION_ZONE = "beacon-event-render-action-zone", r.RENDER_TABLE_CARDS = "beacon-event-render-table-cards", r.LANGUAGE_SELECT = "beacon-event-language-select", r.PLAY = "beacon-event-play", r.CLOSE = "beacon-event-close", r.OPEN = "beacon-event-open", r.NAV_LANGUAGE_SELECT = "beacon-event-language-selected", r.CLOSE_ACTIVE_NAV_ITEM = "beacon-event-close-active-nav-item", r.ELEMENT_READY = "beacon-event-element-ready", r.ACTIVE_NAV_ITEM = "beacon-event-active-nav-item-change", r.DRILLDOWN = "beacon-event-drilldown", r.DRILLUP = "beacon-event-drillup", r.HEADER_ZONE_CLICK = "beacon-event-navigation-header-zone-click", r.COUNTRY_SELECTOR_CLOSE = "beacon-event-country-selector-close", r.COUNTRY_SELECTOR_OPEN = "beacon-event-country-selector-open", r.COUNTRY_FLAG_CHANGE = "beacon-event-country-flag-change", r.HAS_CURRENT_LINK = "beacon-event-has-current-link", r.REGISTER = "beacon-event-register", r.SKIP_LINK_CLICK = "beacon-event-skip-link-click", r.METRICS_SECTION_CHANGE = "beacon-event-metrics-section-change", r.METRICS_LOCATION_CHANGE = "beacon-event-metrics-location-change", r.METRICS_ID_CHANGE = "beacon-event-metrics-id-change", r;
  }(w || {}),
  Ko = /* @__PURE__ */function (r) {
    return r.CLOSE = "close", r.KEYDOWN = "keydown", r.SCROLL = "scroll", r.CLICK = "click", r.FOCUSOUT = "focusout", r;
  }(Ko || {});
var Yo = qe(_templateObject || (_templateObject = _taggedTemplateLiteral(["[beacon-tag-name]:not([focus-override]) *:focus-visible:not(a){--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}[beacon-tag-name]:not([focus-override]) a:focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));background-color:var(--beacon-system-color-background-link-focus, var(--beacon-color-background-link-focus))!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) 0 0 var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus));color:var(--beacon-system-color-text-set-navy, var(--beacon-color-text-set-navy))!important;outline:none;text-decoration:none}@media (forced-colors: active){[beacon-tag-name]:not([focus-override]) a:focus-visible{border-block-end:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) solid var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus))}}\n"]))),
  Qo = qe(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([":host(:not([focus-override])) *:not(a):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}:host(:not([focus-override])) a:focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));background-color:var(--beacon-system-color-background-link-focus, var(--beacon-color-background-link-focus))!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) 0 0 var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus));color:var(--beacon-system-color-text-set-navy, var(--beacon-color-text-set-navy))!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:not([focus-override])) a:focus-visible{border-block-end:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) solid var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus))}}\n"]))),
  Zo = qe(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([":host{border:initial;box-sizing:border-box;display:block;font-size:initial;font-style:initial;font-variant:initial;font-weight:initial;line-height:initial;white-space:initial;word-break:break-word;word-spacing:initial;text-align:initial;text-indent:initial;text-transform:initial}:host *,:host *:before,:host *:after{box-sizing:inherit}input,button,textarea,select{font:inherit;letter-spacing:inherit}button{color:inherit;cursor:pointer}ul,ol{list-style-position:initial;list-style-type:revert}table{caption-side:initial;empty-cells:initial;border-collapse:initial;border-spacing:initial}\n"]))),
  Xo = qe(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([".has-cell-padding{padding-block:var(--beacon-cell-space-padding);padding-inline:var(--beacon-cell-space-padding)}.has-component-padding{padding-block:var(--beacon-component-space-padding);padding-inline:var(--beacon-component-space-padding)}@media (min-width: 1600px){:host{--beacon-space-default: calc(10 * var(--beacon-unit-base)) !important;--beacon-grid-layout-space-margin: 10rem !important;--beacon-grid-gutter-size-inline: 2rem !important}}:host{color:var(--beacon-system-color-text-standard, var(--beacon-color-text-default));font-family:var(--beacon-system-font-family, var(--beacon-font-family-default));-webkit-font-smoothing:antialiased;letter-spacing:var(--beacon-system-font-letter-spacing, var(--beacon-font-letter-spacing-default))}[lang=zh]{font-family:var(--beacon-system-font-family, var(--beacon-font-family-cjk));letter-spacing:var(--beacon-system-font-letter-spacing, var(--beacon-font-letter-spacing-cjk))}a,::slotted(a){color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-default))}a:not(:is(:hover,:focus)){text-decoration:none}:host(:not([motion-state=enabled])),:host(:not([motion-state=enabled])) :is(*,*:before,*:after),:host(:not([motion-state=enabled])) ::slotted(*:not([motion-state=enabled])){animation:none!important;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}\n"]))),
  ee = function ee() {
    _classCallCheck(this, ee);
  };
ee.setPropertyOnEvent = function (r, e, t, o) {
  try {
    Object.defineProperty(r, t, {
      value: o || e["".concat(t)],
      writable: !1
    });
  } catch (_unused13) {}
};
ee.getAnalyticsEvents = function () {
  var r = ["gesture", "click", "touch", "change"];
  return Object.keys(window).filter(function (e) {
    return /^on/.test(e) && new RegExp(r.join("|")).test(e);
  });
};
ee.setHostEventHandlerForAnalytics = function (r, e) {
  var t;
  var o = ee.getAnalyticsEvents(),
    n = "beaconVersion";
  var _iterator13 = _createForOfIteratorHelper(o),
    _step13;
  try {
    var _loop = function _loop() {
      var s = _step13.value;
      var a = s.slice(2);
      (t = r.shadowRoot) == null || t.addEventListener(a, function (c) {
        var h;
        var u = new c.constructor(a, c);
        ee.setPropertyOnEvent(u, null, n, e);
        for (var m in c) ee.setPropertyOnEvent(u, c, m);
        (h = r.shadowRoot) != null && h.contains(c.target) && r.dispatchEvent(u);
      }, !0);
    };
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }
};
var Jo = ee;
function T(r, e, t) {
  var o = new CustomEvent(e, _objectSpread({
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {}
  }, t));
  return r.dispatchEvent(o), o;
}
var Er = function Er(r) {
    return !!navigator.vendor && navigator.vendor.indexOf(r) > -1;
  },
  ei = "3.0.0",
  ti = {
    rootMargin: "1500px",
    threshold: 0.1
  },
  L = {
    version: ei,
    visible: "visible",
    hidden: "hidden",
    safari: "Apple",
    divTagName: "div",
    deprecatedPropertyKeys: ["alternateAttributes", "sync", "alternateSlot"],
    defaultDeferOptions: ti
  },
  gt = function gt(r) {
    var _iterator14 = _createForOfIteratorHelper(r),
      _step14;
    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var e = _step14.value;
        if (e !== void 0) return e;
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
  };
var ri = Object.defineProperty,
  oi = Object.getOwnPropertyDescriptor,
  M = function M(r, e, t, o) {
    for (var n = o > 1 ? void 0 : o ? oi(e, t) : e, s = r.length - 1, a; s >= 0; s--) (a = r[s]) && (n = (o ? a(e, t, n) : a(n)) || n);
    return o && n && ri(e, t, n), n;
  };
var b = /*#__PURE__*/function (_pe) {
  _inherits(ue, _pe);
  function ue() {
    var _this8;
    _classCallCheck(this, ue);
    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(ue).apply(this, arguments)), _this8.isDeferUntilParent = !1, _this8.focusOverride = !1, _this8.beaconTagName = "", _this8.version = L.version, _this8.motionState = "disabled", _this8.alternateSlots = /* @__PURE__ */new Map(), _this8.onslotchange = function (e) {
      var t;
      var o = (t = e.target.name) != null ? t : "";
      _this8.slotDeprecationWarn(o);
    }, _this8.resolvedDeferOptions = {
      root: document,
      rootMargin: L.defaultDeferOptions.rootMargin,
      threshold: L.defaultDeferOptions.threshold
    }, _this8.deferUntilVisible = function () {
      return "IntersectionObserver" in window ? new Promise(function (e) {
        var t = new IntersectionObserver(function (o) {
          var _o4 = _slicedToArray(o, 1),
            n = _o4[0];
          n.isIntersecting && (t.disconnect(), e());
        }, _this8.getResolvedDeferOptions() || null);
        t.observe(_assertThisInitialized(_assertThisInitialized(_this8)));
      }) : new Promise(function (e) {
        e();
      });
    }, _this8.deferUntilIdle = function () {
      var e = new Promise(function (t) {
        document.readyState !== "complete" ? window.addEventListener("load", function () {
          return t();
        }, {
          once: !0
        }) : t();
      });
      return "requestIdleCallback" in window ? Promise.all([new Promise(function (t) {
        requestIdleCallback(function () {
          t();
        });
      }), e]) : e;
    }, _this8.deferredChildEventHandler = function (e) {
      var t;
      e && (_this8.deferOptions && _this8.setDeferOptions(_this8.deferOptions), e instanceof CustomEvent && (t = e.detail) != null && t.type && (_this8.selectDeferUntilHandler(e.detail.type), e.target && _this8.removeClosestDeferredParentEventListener(e.target)));
    }, _this8.errorMode = window.BeaconErrorMode || he.WARN, _this8.requiredPropsList = [], _this8.validatedSlotsList = [], _this8.validateRequiredProps = function () {
      var e, t;
      (t = (e = _this8.renderRoot) == null ? void 0 : e.querySelector("#".concat(k.REQUIRED_PROP_ERROR))) == null || t.remove(), _this8.requiredProps.forEach(function (o) {
        var n;
        var s = "slot".concat(o ? "[name=".concat(String(o), "]") : ":not([name])"),
          a = (n = _this8.renderRoot) == null ? void 0 : n.querySelector(s),
          c = a ? a.assignedNodes() : [];
        if (!_this8[o] && c.length <= 0) {
          var h = _this8.createPropErrorMessage(o);
          _this8.generateError(h, k.REQUIRED_PROP_ERROR);
        }
      });
    }, _this8.generateError = function (e, t) {
      switch (_this8.errorMode) {
        case he.OFF:
          break;
        case he.ERROR:
          throw new Error(e);
        case he.BROWSER:
          _this8.handleBrowserError(e, t);
        case he.WARN:
        default:
          console.warn(e);
          break;
      }
    }, _this8.validateRequiredSlots = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var e, t;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            (t = (e = _this8.renderRoot) == null ? void 0 : e.querySelector("#".concat(k.REQUIRED_SLOT_ERROR))) == null || t.remove();
            _context2.next = 3;
            return _this8.updateComplete;
          case 3:
            _this8.validatedSlots.forEach(function (o) {
              if (!_this8[o].length) {
                var n = _this8.createSlotErrorMessage(o, "item not present while required!");
                _this8.generateError(n, k.REQUIRED_SLOT_ERROR);
              }
            });
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this8.validateSlotChildrenMax = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t;
      _this8.renderRoot && ((t = _this8.renderRoot.querySelector("#".concat(k.MAX_SLOT_ERROR))) == null || t.remove(), _this8.validatedSlots.forEach(function (o) {
        if (_this8[o].length > e || _this8.validateAnySlottedExceedMax(o, e)) {
          var n = _this8.createSlotErrorMessage(o, "Maximum children exceeded ".concat(e));
          _this8.generateError(n, k.MAX_SLOT_ERROR);
        }
      }));
    }, _this8.validateSlotChildrenMin = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t;
      _this8.renderRoot && ((t = _this8.renderRoot.querySelector("#".concat(k.MIN_SLOT_ERROR))) == null || t.remove(), _this8.validatedSlots.forEach(function (o) {
        if (_this8[o].length < e || _this8.validateAnySlottedBelowMin(o, e)) {
          var n = _this8.createSlotErrorMessage(o, "Children below minimum ".concat(e));
          _this8.generateError(n, k.MIN_SLOT_ERROR);
        }
      }));
    }, _this8.validateSlottedItemLengthsEqual = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var e, t, o;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this8.updateComplete;
          case 2:
            _this8.validatedSlots.forEach(function (n, s) {
              s === 0 && (e = n, t = _this8[n], o = t.length);
              var a = _this8[n];
              if (a.length !== o) {
                var c = _this8.createSlotErrorMessage(n, "length: ".concat(a.length, " does not match ").concat(e, " length: ").concat(o));
                _this8.generateError(c, k.UNEQUAL_SLOT_ERROR);
              }
            });
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), _this8.renderLightDOMStyles = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "".concat(_this8.beaconTagName, "-light-DOM-styles");
      var t = [],
        o = new Set(_this8.constructor.lightDOMStyles.flat(1 / 0));
      var _iterator15 = _createForOfIteratorHelper(o),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var n = _step15.value;
          t.push(n);
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      t.reverse().forEach(function (n, s) {
        var a;
        var c = document.createElement("style");
        c.setAttribute("slot", "lightDOM");
        var h = !1;
        if (c.textContent = n.toString(), e) {
          var u = Math.abs(s - t.length),
            m = "".concat(e, "-").concat(u),
            f = _this8.getClosestHost();
          c.id = m, (f && (a = f == null ? void 0 : f.shadowRoot) != null && a.querySelector("#".concat(m)) || !f && document.querySelector("#".concat(m))) && (h = !0);
        }
        h || _this8.prepend(c);
      });
    }, _this8.renderComponentModeStyles = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "".concat(_this8.beaconTagName, "-mode-styles");
      var t;
      (t = _this8.componentModeStyles) == null || t.forEach(function (o, n) {
        var s = document.createElement("style");
        s.textContent = o.toString();
        var a = "".concat(e, "-").concat(n);
        s.id = a, !document.querySelector("#".concat(a)) && document.head.append(s);
      });
    }, _this8.validateAnySlottedExceedMax = function (e, t) {
      return _this8[e].some(function (o) {
        return _this8.validateDivNestedSlotExceedMax(o, t);
      });
    }, _this8.validateDivNestedSlotExceedMax = function (e, t) {
      return e.nodeName === L.divTagName ? e.children.length > t : !1;
    }, _this8.validateAnySlottedBelowMin = function (e, t) {
      return _this8[e].some(function (o) {
        return _this8.validateDivNestedSlotBelowMin(o, t);
      });
    }, _this8.validateDivNestedSlotBelowMin = function (e, t) {
      return e.nodeName === L.divTagName ? e.children.length < t : !1;
    }, _this8.createSlotErrorMessage = function (e, t) {
      return "Slot Validation Error: ".concat(_this8.nodeName, " slot \"").concat(String(e), "\" ").concat(t);
    }, _this8.createPropErrorMessage = function (e) {
      return "Prop Validation Error: ".concat(_this8.nodeName, " requires ").concat(String(e), " property value");
    }, _this8.getScopedTag = function (e) {
      if (!e) return null;
      var t = _this8.getScopedTagPrefix() ? "".concat(_this8.getScopedTagPrefix(), "-").concat(e) : e;
      return bo(t);
    }, _this8.handleBrowserError = function (e, t) {
      var o = document.createElement("p");
      o.id = t, o.style.color = "red", o.innerText = e, _this8.renderRoot.appendChild(o);
    };
    return _this8;
  }
  /**
   * Extends Lit's definition of `observedAttributes`.
   *
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */
  _createClass(ue, [{
    key: "attributeChangedCallback",
    /**
     * Extends Lit's default attributeChangedCallback to support deprecated properties.
     *
     * @param name Attribute name
     * @param _old Old value
     * @param value New value
     */
    value: function attributeChangedCallback(e, t, o) {
      var _this$constructor = this.constructor,
        n = _this$constructor.alternateAttributesMap,
        s = _this$constructor.hasDeprecatedProperties,
        a = _this$constructor.elementProperties;
      if (s && n.size > 0) {
        var c = n.get(e),
          h = a.get(c),
          u = this.getPropertyOptions(e).alternateSlot;
        if (c) if (c !== He.NO_SYNC && (o === null ? this.removeAttribute((h == null ? void 0 : h.attribute) || c) : this.setAttribute((h == null ? void 0 : h.attribute) || c, o || "")), u) {
          var m = this.createPropertyDeprecationForSlotMessage(e, u);
          console.warn(m);
        } else console.warn(this.createPropertyDeprecationMessage(e, c, h == null ? void 0 : h.attribute));
      }
      _get(_getPrototypeOf(ue.prototype), "attributeChangedCallback", this).call(this, e, t, o);
    }
    /**
     * Generates a console message to log when deprecated properties were used.
     *
     * @param name attribute that triggered the message
     * @param property property that the attribute aligns to
     * @param attribute correct attribute to use
     */
  }, {
    key: "createPropertyDeprecationMessage",
    value: function createPropertyDeprecationMessage(e, t, o) {
      var n = "Beacon Warning: [".concat(e, "] will be deprecated as a prop of <").concat(this.beaconTagName.toLowerCase(), "> in a future release.");
      return t !== He.NO_SYNC && (n += " Start using [".concat(o || t, "] instead to avoid future disruptions.")), n;
    }
    /**
     * Generates a console message to log when a deprecated property is used
     * and should instead use the designated slot
     * @param property the name of the property being deprecated
     * @param slot the designated slot to use instead
     */
  }, {
    key: "createPropertyDeprecationForSlotMessage",
    value: function createPropertyDeprecationForSlotMessage(e, t) {
      return "Beacon Warning: '".concat(e, "' will be deprecated as a prop of <").concat(this.beaconTagName.toLowerCase(), "> in a future release. Start using the slot: '").concat(t, "' instead to avoid future disruptions");
    }
    /**
     * Extend's Lit's `createProperty` method for our own uses.
     * @param name Property Name
     * @param options Options for the property
     */
  }, {
    key: "getPropertyOptions",
    /**
     * This is used to return the property options of a property when given only its attribute name,
     * e.g. the property pageTitle with an attribute name of 'page-title' will have no way of accessing its options
     * directly when attempting to grab the options with 'page-title' and elementProperties.get().
     * @param name the resolved attribute name of a `@property()` decorated property
     * @returns the options passed in `@property()` e.g. `{attribute: 'attribute-name', reflect: true}`
     */
    value: function getPropertyOptions(e) {
      var t;
      var o = this.constructor.elementProperties;
      return (t = o.get(e)) != null ? t : _toConsumableArray(o.values()).find(function (n) {
        return n.attribute === e;
      });
    }
    /**
     * Getter that returns private resolvedDeferOptions
     * @returns resolvedDeferOptions that are passed to an IntersectionObserver
     */
  }, {
    key: "getResolvedDeferOptions",
    value: function getResolvedDeferOptions() {
      return this.resolvedDeferOptions;
    }
    /**
     * Converts space separated list prop of `defer-until` to a DeferUntil enum array
     */
  }, {
    key: "slotDeprecationWarn",
    /**
     * Logs a warning based on the slot name provided and details from the alternate slots map
     *
     * @param slotName name of the slot that has changed
     */
    value: function slotDeprecationWarn(e) {
      var t = this.alternateSlots.get(e);
      if (t !== void 0) {
        var o;
        var n = "The '".concat(e, "' for for '").concat(this.beaconTagName, "'");
        Object.keys(t).some(function (s) {
          return s.match("alternate");
        }) ? t.alternateAttribute ? o = "will be replaced by the element property '".concat(t.alternateAttribute, "'") : o = "will be replaced by the '".concat(t.alternateSlots, "' slot") : o = "will be removed", console.warn("Beacon Deprecation Warning: ".concat(n, " ").concat(o, " in foundation@").concat(t.version));
      }
    }
    /**
     * A setter that takes user input deferOptions and resolves them compared to existing deferOptions. Enables the setting
     * of isolated deferOptions and leaves unchanged options previously set intact.
     * @param options the defer-options object used in IntersectionObserver.
     */
  }, {
    key: "setDeferOptions",
    value: function setDeferOptions(e) {
      if (!e) return;
      var t = _objectSpread({}, this.resolvedDeferOptions);
      this.resolvedDeferOptions = {
        root: gt([e == null ? void 0 : e.root, t == null ? void 0 : t.root, document]),
        rootMargin: gt([e == null ? void 0 : e.rootMargin, t == null ? void 0 : t.rootMargin, L.defaultDeferOptions.rootMargin]),
        threshold: gt([e == null ? void 0 : e.threshold, t == null ? void 0 : t.threshold, L.defaultDeferOptions.threshold])
      };
    }
    /**
     * Hides the visibility of the component. Used when component is deferred until specified condition.
     * @returns void
     */
  }, {
    key: "setDeferVisibilityStyles",
    value: function setDeferVisibilityStyles() {
      Er(L.safari) || (this.style.visibility = L.hidden);
    }
    /**
     * Sets the component styles to visibile. Used when component meets condition specified to defer until.
     * @returns void
     */
  }, {
    key: "removeDeferVisibilityStyles",
    value: function removeDeferVisibilityStyles() {
      Er(L.safari) || (this.style.visibility = L.visible);
    }
    /**
     * Searches for a parent of component with defer-until attribute.
     * @returns closest lightDOM parent with [defer-until] attribute or null
     */
  }, {
    key: "getClosestDeferredParent",
    value: function getClosestDeferredParent() {
      var e = "[defer-until]",
        t = this.closest(e);
      if (t) return t;
      var o = this.getClosestHost();
      return o ? o.closest(e) : null;
    }
    /**
     * Runs in shadowDOM context. This method searches for the ShadowRoot then returns host of ShadowRoot.
     * @returns host element of this component of the shadowDOM
     */
  }, {
    key: "getClosestHost",
    value: function getClosestHost() {
      var e = this && this.parentNode;
      for (; e;) {
        if (e instanceof ShadowRoot) return e.host;
        e = e.parentNode;
      }
      return null;
    }
    /**
     * Selects which deferUntil handler method to run on component.
     * @param deferUntilCriteria DeferUntil option that determines how component should defer.
     */
  }, {
    key: "selectDeferUntilHandler",
    value: function selectDeferUntilHandler(e) {
      var _this9 = this;
      var t, o;
      e.includes(Be.VISIBLE) ? (this.setDeferVisibilityStyles(), (t = this.deferUntilVisible()) == null || t.then(function () {
        _this9.removeDeferVisibilityStyles();
      })) : e.includes(Be.IDLE) && (this.setDeferVisibilityStyles(), (o = this.deferUntilIdle()) == null || o.then(function () {
        _this9.removeDeferVisibilityStyles();
      }));
    }
    /**
     * Method that handles setup of deferUntil handler when deferUntil is configured locally via deferUntil prop on the component.
     */
  }, {
    key: "handleLocalDeferUntil",
    value: function handleLocalDeferUntil() {
      this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(this.deferList);
    }
    /**
     * Method that looks for the closest element to the component with 'defer-until' attribute and either
     * applies the parent's deferUntil logic to the component immediately, if the parent is already registered as `isDeferUntilParent`,
     * or adds an eventListener to toggle parent's deferUntil logic on component once parent has emitted the beacon-event-deferred-child Event.
     * @param closestDeferredParent is the closeset element to the component that has the 'defer-until' attribute set.
     */
  }, {
    key: "handleParentalDeferUntil",
    value: function handleParentalDeferUntil(e) {
      e && (e.isDeferUntilParent && e.deferUntil ? this.selectDeferUntilHandler(e.deferUntil) : e.addEventListener(w.DEFERRED_CHILD, this.deferredChildEventHandler));
    }
    /**
     * Method to remove eventListener on closest element to the component with 'defer-until' attribute
     * @param closestDeferredParent closest element to the component with 'defer-until' attribute
     */
  }, {
    key: "removeClosestDeferredParentEventListener",
    value: function removeClosestDeferredParentEventListener(e) {
      e && e.removeEventListener(w.DEFERRED_CHILD, this.deferredChildEventHandler);
    }
    /**
     * This method handles defer logic. If component has deferUntil prop set, it calls method to handle deferUntil logic locally.
     * Else if component has a closest element with 'defer-until' attribute set, it handles deferUntil based on closestDeferredParent's deferUntil settings.
     * If neither of the above criteria match, it completes connectedCallback.
     */
  }, {
    key: "handleDefer",
    value: function handleDefer() {
      if (this.deferUntil) return this.registerAsDeferUntilParent(), this.handleLocalDeferUntil(), new Promise(function (t) {
        t();
      });
      var e = this.getClosestDeferredParent();
      return e ? (this.handleParentalDeferUntil(e), new Promise(function (t) {
        t();
      })) : new Promise(function (t) {
        t();
      });
    }
    /**
     * Method that registers a component as parental component that can trigger deferUntil logic in child components. It should be placed in connectedCallback
     * of all components that need to trigger deferUntil logic in child components.
     */
  }, {
    key: "registerAsDeferUntilParent",
    value: function registerAsDeferUntilParent() {
      var _this10 = this;
      if (this.deferOptions && this.setDeferOptions(this.deferOptions), this.deferList.includes(Be.VISIBLE)) {
        var e = new IntersectionObserver(function (t) {
          var _iterator16 = _createForOfIteratorHelper(t),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var o = _step16.value;
              o.target && (_this10.isDeferUntilParent = !0, _this10.emitDeferredChild(), e.disconnect());
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        }, this.getResolvedDeferOptions() || null);
        e.observe(this);
      }
    }
  }, {
    key: "getScopedTagPrefix",
    /**
     * @returns the scope prefix
     */
    value: function getScopedTagPrefix() {
      return ue.scopePrefix;
    }
    /**
     * Sets the prefix prepended to beacon component tags in HTML templates.
     * @param {string} dirtyPrefix - a prefix string passed in via registerComponents utility for scoping the beacon library.
     */
  }, {
    key: "validateDefaultSlot",
    /**
     * Method for Default slot Validation.
     */
    value: function validateDefaultSlot() {
      var e, t, o, n, s, a;
      if ((t = (e = this.renderRoot) == null ? void 0 : e.querySelector("#".concat(k.REQUIRED_DEFAULT_SLOT_ERROR))) == null || t.remove(), !((a = (s = (n = (o = this.renderRoot) == null ? void 0 : o.querySelector("slot:not([name])")) == null ? void 0 : n.assignedNodes()) == null ? void 0 : s.filter(function (c) {
        var h;
        return (h = c.nodeValue) == null ? void 0 : h.trim();
      })) != null && a.length)) {
        var c = "Prop Validation Error: ".concat(this.nodeName, " requires default slot value");
        this.generateError(c, k.REQUIRED_DEFAULT_SLOT_ERROR);
      }
    }
    /**
     * This will return beacon tag name to scoped tag Name
     * @param tag beaconTagName
     * @returns Scoped tagName
     */
  }, {
    key: "getScopedTagName",
    value: function getScopedTagName(e) {
      return e ? this.getScopedTagPrefix() ? "".concat(this.getScopedTagPrefix(), "-").concat(e) : e : "";
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-render-action-zone - emits when the action zone is rendered inside a table
     */
  }, {
    key: "emitRenderActionZone",
    value: function emitRenderActionZone(e) {
      T(this, w.RENDER_ACTION_ZONE);
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-input - emits when a standard input event would be fired
     */
  }, {
    key: "emitInput",
    value: function emitInput(e, t) {
      T(this, w.INPUT), this.onBeaconInput && this.onBeaconInput(t);
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-change - emits when a standard change event would be fired
     */
  }, {
    key: "emitChange",
    value: function emitChange(e, t) {
      T(this, w.CHANGE), this.onBeaconChange && this.onBeaconChange(t);
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-focus - emits when a beacon form component receives focus
     */
  }, {
    key: "emitFocus",
    value: function emitFocus(e, t) {
      T(this, w.FOCUS), this.onBeaconFocus && this.onBeaconFocus(t);
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-blur - emits when a beacon form component loses focus
     */
  }, {
    key: "emitBlur",
    value: function emitBlur(e, t) {
      T(this, w.BLUR), this.onBeaconBlur && this.onBeaconBlur(t);
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-click - emits when clicked
     */
  }, {
    key: "emitClick",
    value: function emitClick(e, t) {
      T(this, w.CLICK), this.onBeaconClick && this.onBeaconClick(t);
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-mousedown - emits when a mousedown event would be fired
     */
  }, {
    key: "emitMousedown",
    value: function emitMousedown(e, t) {
      T(this, w.MOUSEDOWN), this.onBeaconMousedown && this.onBeaconMousedown(t);
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
     */
  }, {
    key: "emitKeydown",
    value: function emitKeydown(e, t) {
      T(this, w.KEYDOWN), this.onBeaconKeydown && this.onBeaconKeydown(t);
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-render - emits when a component is rendered
     */
  }, {
    key: "emitRender",
    value: function emitRender(e) {
      T(this, w.RENDER);
    }
    /**
     * Emitter of beacon-event-deferred-child event used by components registered as deferUntilParents.
     * @param event
     * @event {BeaconEvents} beacon-event-deffered-child - signals to children of a deferUntil parent that they should behave as deferUntil components
     */
  }, {
    key: "emitDeferredChild",
    value: function emitDeferredChild(e) {
      T(this, w.DEFERRED_CHILD, {
        detail: {
          element: this,
          type: this.deferList
        }
      });
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-mouseenter - emits when a mouse enters the component
     */
  }, {
    key: "emitMouseEnter",
    value: function emitMouseEnter(e) {
      T(this, w.MOUSEENTER);
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-mouseleave - emits when a mouse leaves the component
     */
  }, {
    key: "emitMouseLeave",
    value: function emitMouseLeave(e) {
      T(this, w.MOUSELEAVE);
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-hide - emits when this slotted component should be hidden by a parent component
     */
  }, {
    key: "emitHide",
    value: function emitHide(e) {
      T(this, w.HIDE);
    }
    /**
     * Emits a beacon-event-mousedown event as a default to mousedown handling
     * @param event
     */
  }, {
    key: "handleMousedown",
    value: function handleMousedown(e) {
      this.emitMousedown(e);
    }
    /**
     * Emits a beacon-event-keydown event as a default to mousedown handling
     * @param event
     */
  }, {
    key: "handleKeydown",
    value: function handleKeydown(e) {
      this.emitKeydown(e);
    }
    /**
     * Check if the component has a specific mixin applied.
     * @param name Name of the mixin to look for.
     * @returns True if the class contains that mixin.
     */
  }, {
    key: "hasMixin",
    value: function hasMixin(e) {
      var t;
      try {
        if (!((t = this.constructor.mixins) != null && t.includes(e))) throw new Error("This class does not implement ".concat(e, "."));
        return !0;
      } catch (o) {
        return console.error(o), !1;
      }
    }
    /**
     * Check for a field with a specific value on the class.
     *
     * Useful when a mixin relies on the existance of another mixin.
     *
     * @param field Class property to check for on the mixin.
     * @param value Value of the given class field to check for.
     * @returns True if the value of the field is the same.
     */
  }, {
    key: "hasFieldAndValue",
    value: function hasFieldAndValue(e, t) {
      try {
        if (!(e in this)) throw new Error("".concat(e, " does not exist on this: ").concat(this));
        return this[e] === t;
      } catch (o) {
        return console.error(o), !1;
      }
    }
  }, {
    key: "prerender",
    value: function prerender() {}
  }, {
    key: "postrender",
    value: function postrender() {}
  }, {
    key: "destroy",
    value: function destroy() {}
    /**
     * Enables or disables motion on this component.
     *
     * Looks for the closest element with `[motion-state]` to find its value and set the motion state of the component equal to that.
     *
     * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest Element.closest() will return the element itself if it matches the selector.
     */
  }, {
    key: "setMotionState",
    value: function setMotionState() {
      if (this.motionState === "enabled") return;
      var e = this.closest("[motion-state]"),
        t = e == null ? void 0 : e.getAttribute("motion-state");
      t && (t === "enabled" || t === "disabled") && (this.motionState = t);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this11 = this;
      var e;
      (e = this.handleDefer()) == null || e.then(function () {
        _get(_getPrototypeOf(ue.prototype), "connectedCallback", _this11).call(_this11), Jo.setHostEventHandlerForAnalytics(_this11, _this11.version), _this11.setMotionState(), _this11.renderLightDOMStyles(), _this11.prerenderHooks.length ? _this11.prerenderHooks.forEach(function (t) {
          t.bind(_this11)();
        }) : _this11.prerender();
      });
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this12 = this;
      this.validateRequiredProps(), this.validateRequiredSlots(), this.validatedHasDefaultSlot && this.validateDefaultSlot(), this.postrenderHooks.length ? this.postrenderHooks.forEach(function (e) {
        e.bind(_this12)();
      }) : this.postrender(), T(this, w.ELEMENT_READY);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this13 = this;
      _get(_getPrototypeOf(ue.prototype), "disconnectedCallback", this).call(this), this.destroyHooks.length ? this.destroyHooks.forEach(function (e) {
        e.bind(_this13)();
      }) : this.destroy();
    }
  }, {
    key: "deferList",
    get: function get() {
      var e, t;
      return (t = (e = this.deferUntil) == null ? void 0 : e.split(" ").map(function (o) {
        return o;
      }).filter(function (o) {
        return !!o;
      })) != null ? t : [];
    }
  }, {
    key: "requiredProps",
    get: function get() {
      return this.requiredPropsList;
    },
    set: function set(e) {
      this.requiredPropsList = _toConsumableArray(e);
    }
  }, {
    key: "validatedSlots",
    get: function get() {
      return this.validatedSlotsList;
    },
    set: function set(e) {
      this.validatedSlotsList = _toConsumableArray(e);
    }
  }, {
    key: "validatedHasDefaultSlot",
    get: function get() {
      return this.validatedSlots.includes("default");
    }
  }, {
    key: "prerenderHooks",
    get: function get() {
      return [];
    }
  }, {
    key: "postrenderHooks",
    get: function get() {
      return [];
    }
  }, {
    key: "destroyHooks",
    get: function get() {
      return [];
    }
  }], [{
    key: "createProperty",
    value: function createProperty(e, t) {
      var _this14 = this;
      if (t) {
        var o = t.alternateAttributes,
          n = t.attribute,
          s = Object.prototype.hasOwnProperty.call(t, "sync");
        if (L.deprecatedPropertyKeys.forEach(function (a) {
          Object.prototype.hasOwnProperty.call(t, a) && (_this14.hasDeprecatedProperties = !0);
        }), o && o.forEach(function (a) {
          _this14.alternateAttributesMap.set(a, e);
        }), s && !t.sync) {
          var a = n != null ? n : e;
          this.alternateAttributesMap.set(a, He.NO_SYNC);
        }
      }
      _get(_getPrototypeOf(ue), "createProperty", this).call(this, e, t);
    }
  }, {
    key: "setScopedTagPrefix",
    value: function setScopedTagPrefix(e) {
      var t = Go.sanitize(e);
      ue.scopePrefix = t;
    }
    /**
     * Defines this web component in the CustomElementRegistry.
     * @param tagNamePrefix lowercase string that prefixes default component tag names for scoping purposes
     */
  }, {
    key: "registerComponent",
    value: function registerComponent(e) {
      if (this.tagName) {
        ue.setScopedTagPrefix(e);
        var t = "".concat(ue.scopePrefix ? "".concat(ue.scopePrefix, "-") : "").concat(this.tagName);
        if (!customElements.get(t)) {
          customElements.define(t, /*#__PURE__*/function (_this15) {
            _inherits(_class, _this15);
            function _class() {
              _classCallCheck(this, _class);
              return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
            }
            return _class;
          }(this));
          var o = new CustomEvent(w.REGISTER, {
            detail: t
          });
          document.dispatchEvent(o);
        }
      }
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      var _this16 = this;
      var e = [];
      return this.hasDeprecatedProperties && this.alternateAttributesMap.forEach(function (t, o) {
        _this16.elementProperties.has(t) && e.push(o);
      }), e.push.apply(e, _toConsumableArray(_get(_getPrototypeOf(ue), "observedAttributes", this))), e;
    }
  }]);
  return ue;
}(pe);
b.styles = [Zo, Xo, Qo];
b.tagName = "";
b.shadowRootOptions = _objectSpread({}, pe.shadowRootOptions, {
  delegatesFocus: !0
});
b.alternateAttributesMap = /* @__PURE__ */new Map();
b.hasDeprecatedProperties = !1;
b.mixins = [];
b.scopePrefix = null;
b.lightDOMStyles = [Yo];
M([x({
  attribute: "focus-override",
  type: Boolean,
  reflect: !0
})], b.prototype, "focusOverride", 2);
M([x({
  attribute: "beacon-tag-name",
  type: String,
  reflect: !0
})], b.prototype, "beaconTagName", 2);
M([x({
  attribute: "beacon-version",
  reflect: !0
})], b.prototype, "version", 2);
M([x({
  attribute: "defer-until"
})], b.prototype, "deferUntil", 2);
M([x({
  attribute: "defer-options"
})], b.prototype, "deferOptions", 2);
M([x({
  type: Function
})], b.prototype, "onBeaconChange", 2);
M([x({
  type: Function
})], b.prototype, "onBeaconBlur", 2);
M([x({
  type: Function
})], b.prototype, "onBeaconClick", 2);
M([x({
  type: Function
})], b.prototype, "onBeaconInput", 2);
M([x({
  type: Function
})], b.prototype, "onBeaconFocus", 2);
M([x({
  type: Function
})], b.prototype, "onBeaconKeydown", 2);
M([x({
  type: Function
})], b.prototype, "onBeaconMousedown", 2);
M([x({
  attribute: "motion-state",
  reflect: !0
})], b.prototype, "motionState", 2);
var si = b;
export { T as D, qe as Ge, x as M, Ko as Qo, w as T, mo as bo, ii as ci, ni as di, si as fi, ai as hi, fe as me, $ as w, fo as yo };